<template>
  <div style="padding:10px 6px 12px 24px;">
    <ve-line
        width="600px"
        height="350px"
        :data="chartRankingData.data"
        :legend-visible="this.groupType.length > 0"
        :settings="chartRankingData.settings"
        :extend="chartRankingData.options"
        :data-empty="!chartData.length"
        :grid="grid"
    ></ve-line>
    <div style="text-align: center">无数据代表有异常，数据未抓取回来，可以在插件中选择时间自动获取流量报表数据。</div>
  </div>
</template>

<script>
export default {
  name: "statistics-chart",
  props: {
    chartData: {
      type: Array
    },
    type: null,
    groupType: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data() {
    return {
      grid: {
        left: 20,
        right: 40,
        top: 20,
        bottom: 12
      }
    }
  },
  computed: {
    chartRankingData() {
      // if(this.chartData){
      return {
        data: {
          columns: this.groupType.length > 0 ? ['dateLine', ...this.groupType.map(item => item.label)] : ['dateLine', this.type],
          rows: this.chartData.map(r => {
            let row = {
              dateLine: r.date
            }
            if(this.groupType.length > 0) {
              this.groupType.forEach(item => {
                row[item.label] = r.exc ? '' : r[item.field] - 0
              });
            }
            return this.groupType.length > 0 ? row : {
              dateLine: r.date,
              [this.type]: r.exc ? '' : r[this.type] - 0
            }
          })
        },
        options: {
          legend: {
            top: 0,
            padding: 10,
          },
          grid: {
            top: '15%',
            containLabel: true
          },
        }
      }
      // }
    }
  }
}
</script>

<style scoped lang="scss">

</style>